import { render, staticRenderFns } from "./BlankImg.vue?vue&type=template&id=1701d924&scoped=true"
var script = {}
import style0 from "./BlankImg.vue?vue&type=style&index=0&id=1701d924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701d924",
  null
  
)

export default component.exports